<template>
  <div class="ui ui-tutorial">
    <span class="ui-tutorial__bg" />

    <transition @enter="enter" @leave="leave" appear mode="out-in" :css="false">
      <section class="ui-tutorial__phase" data-phase="interaction" v-if="phase === 0" key="interaction">
        <p class="ui-tutorial__content" v-html="$translate('tutorial').content[0]"/>

        <svg class="ui-tutorial__svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 106.8 114.4">
          <path class="svg__hand" d="M60.4,114.4L60.4,114.4c-4.1,0-8.1-1.1-11.6-3.1c-3.8-2.2-6.7-5.4-8.6-9.4c-0.9-1.8-1.9-3.4-3-5
            c-0.5-0.7-1-1.5-1.5-2.3c-2.7-4.4-5.9-9.4-8.5-14.4v0c-0.7-1.1-1-2.4-0.6-3.7c0.2-0.8,0.7-1.5,1.3-2.1c0.6-0.6,1.4-1,2.2-1.2
            c0.5-0.1,0.9-0.2,1.4-0.2c1,0,1.9,0.3,2.8,0.8c0,0,0.1,0.1,0.1,0.1c1.4,1.4,2.8,2.9,4,4.5l0.2,0.3l0.2,0.3c1.2,1.6,2.6,3.2,4,4.6
            l0.2,0.2v-32c0-2.9,2.3-5.2,5.2-5.2s5.2,2.3,5.2,5.2v14.1c2.4-2.1,6.1-1.9,8.2,0.5c0.6,0.7,1,1.5,1.2,2.3c2.1-2,5.3-2.1,7.5-0.3
            c1,0.8,1.7,1.9,2,3.2c0.9-0.7,1.9-1.1,3-1.1c1.2-0.1,2.4,0.3,3.3,1.2c1.5,1.6,1.5,4.4,1.5,6.7c-0.1,7-0.5,14-0.8,19.3
            c-0.2,4.9-2.5,9.4-6.3,12.5C69.5,112.9,65,114.4,60.4,114.4z M39.1,96.3c1.1,1.5,2,3.1,2.8,4.8c1.3,2.7,3.2,5.1,5.5,7
            c2.4,1.9,5.1,3.2,8.1,3.8c1.6,0.4,3.2,0.5,4.8,0.5c2,0,3.9-0.3,5.8-0.8c1.9-0.6,3.7-1.4,5.2-2.6c3.6-2.7,5.8-6.9,6-11.5
            c0.1-0.9,0.1-1.7,0.2-2.4h-0.1c0.4-6.7,0.7-12,0.7-18v-1.8c0-1.6-1.3-2.8-2.8-2.8c-1.4,0-2.6,1-2.8,2.4v5.5c0,0.6-0.5,1-1,1
            c-0.6,0-1-0.5-1-1v-7.2h0v-0.3c0-2.1-1.7-3.7-3.7-3.7c-1.9,0-3.4,1.4-3.7,3.2v5.2c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1v-7.8
            c-0.3-2.1-2.2-3.5-4.3-3.3c-1.7,0.2-3,1.6-3.3,3.3c0,0.7,0,1.5,0,2.2c0,0.6,0,1.3,0,1.9c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1v-1.5
            c0-1.3,0-2.7,0-4c0-0.7,0-1.3,0-2V51.8c0-1.8-1.5-3.3-3.3-3.3S45,50,45,51.8v32c0,0.8-0.4,1.5-1.2,1.8c-0.3,0.1-0.5,0.2-0.8,0.2
            c-0.5,0-0.9-0.2-1.3-0.5L41.4,85c-1.6-1.5-3-3.1-4.3-4.8l-0.2-0.3l-0.3-0.4l0,0c-1.1-1.5-2.3-2.8-3.6-4.1c-0.5-0.3-1-0.5-1.6-0.5
            c-0.3,0-0.6,0-0.9,0.1c-0.5,0.1-1,0.4-1.4,0.8c-0.4,0.3-0.6,0.7-0.8,1.2c-0.2,0.7,0,1.5,0.4,2l0,0c0,0.1,0.1,0.1,0.1,0.1
            c2.7,5,5.7,9.9,8.5,14.3c0.3,0.5,0.7,1,1,1.6l0,0l0.1,0.1C38.7,95.5,38.9,95.9,39.1,96.3L39.1,96.3L39.1,96.3z" fill="#EDF44F" />
          <path d="M105.9,34C95.8,14.4,76.1,1,53.4,1S11,14.4,0.9,34" fill="none" stroke="#707070" stroke-width="2" stroke-miterlimit="10" />
          <path class="svg__fill" d="M105.9,34C95.8,14.4,76.1,1,53.4,1S11,14.4,0.9,34" fill="none" stroke="#EDF44F" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </section>

      <section class="ui-tutorial__phase" data-phase="leaves" v-if="phase === 1" key="leaves">
        <div class="ui-tutorial__content-cont">
          <p class="ui-tutorial__content" v-html="$translate('tutorial').content[1]" />
          <img class="ui-tutorial__image" src="/img/tutorial/tutorial-flower-00.png" alt="leaf icon image">
        </div>

        <div class="ui-tutorial__content-cont">
          <p class="ui-tutorial__content" v-html="$translate('tutorial').content[2]" />
          <img class="ui-tutorial__image" src="/img/tutorial/tutorial-flower-01.png" alt="leaf icon image">
        </div>
      </section>

      <section class="ui-tutorial__phase" data-phase="fruits" v-if="phase === 2" key="fruits">
        <p class="ui-tutorial__content" v-html="$translate('tutorial').content[3]"/>

        <div class="ui-tutorial__fruits">
          <img class="ui-tutorial__image" src="/img/tutorial/tutorial-fruit-00.png" alt="Nut">
          <p class="ui-tutorial__separator">or</p>
          <img class="ui-tutorial__image" src="/img/tutorial/tutorial-fruit-01.png" alt="Sunflower seed">
        </div>
      </section>
    </transition>

    <button class="ui-tutorial__skip" @click="skip">
      <p>{{ $translate('tutorial').close }}</p>
    </button>
  </div>
</template>

<script>
import transitions from '@/scripts/transitions';
import audio from '@/scripts/audio';

export default {
  name: 'Tutorial',

  data() {
    return {
      phase: 0,
      timer: null,
    };
  },

  methods: {
    incrementPhase() {
      if (this.phase === 2) {
        this.$store.commit('SET_MODE', 'playing');
        audio.play('countdown');
        setTimeout(() => {
          this.$game.startPlaying();
        }, 3000);
        this.phase = 0;
      } else {
        this.phase += 1;
      }

      window.clearTimeout(this.timer);
      this.timer = null;
    },
    skip() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }

      this.$store.commit('SET_MODE', 'playing');
      audio.play('countdown');
      setTimeout(() => {
        this.$game.startPlaying();
      }, 3000);
    },
    initTimer() {
      this.timer = window.setTimeout(this.incrementPhase, this.phase === 0 ? 3500 : 2200);
    },
    enter(el, done) {
      const { phase } = el.dataset;

      transitions.get(`tutorial-${phase}-enter`)(el).then(() => {
        done();
        this.initTimer();
      });
    },
    leave(el, done) {
      transitions.get('tutorial-phase-leave')(el).then(done);
    },
  },

  beforeDestroy() {
    if (this.timer) window.clearTimeout(this.timer);
  },
};
</script>

<style lang="scss">
@keyframes ripple {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}

.ui-tutorial {
  text-align: center;
  color: $color-yellow;
  pointer-events: all;

  &,
  &__phase,
  &__circle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &,
  &__bg {
    @include full();
  }

  &__bg {
    background-color: rgba($color-green, 0.9);
  }

  &__phase {
    margin-top: -15vh;
    height: 30vh;

    justify-content: space-between;
    flex-flow: column nowrap;

    &[data-phase="leaves"] {
      margin-top: 0;
      height: 45vh;

      img {
        margin-top: 20px;
      }
    }
  }

  &__content-cont {
    position: relative;
  }

  &__content,
  &__circle,
  &__leaf,
  &__seeds {
    position: relative;

    font-weight: 800;
    line-height: 1.6;

    font-size: 16px;

    @include mq(ipadP) {
      font-size: 18px;
    }

    @include mq(ds) {
      font-size: 20px;
    }

    @include mq(dxl) {
      font-size: 22px;
    }
  }

  &__content {
    padding: 0px 20vw;
  }

  &__svg {
    position: relative;
    width: 100px;

    overflow: visible;
  }

  &__circle {
    width: 20vh;
    height: 20vh;
    flex: 0 0 auto;
    margin-top: 10vh;

    color: inherit;
    cursor: pointer;

    @include mq($until: ipadL) {
      max-width: 200px;
      max-height: 200px;
    }

    &,
    .circle__repeater {
      border-radius: 50%;
      border: 1px solid $color-white;
    }

    .circle__repeater {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      @for $i from 6 through 1 {
        &:nth-child(#{$i}) {
          animation: ripple 4s infinite $ease-out;
          animation-delay: (500ms * $i);
        }
      }
    }
  }

  &__fruits {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .ui-tutorial__separator {
      margin: 0 10px 0 15px;
    }
  }

  &__image {
    position: relative;
    width: 45px;
  }

  &__skip {
    position: absolute;
    bottom: 28px;
    left: 50%;

    color: inherit;
    @extend %font-small;

    transform: translateX(-50%);
    cursor: pointer;

    p {
      text-decoration: underline;
    }

    @include mq(ipadP) {
      bottom: 38px;
    }

    @include mq(dm) {
      bottom: 48px;
    }
  }
}
</style>
